import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

export const ButtonBase = styled(Button)(({ theme, ...props }) => ({
  backgroundColor: props.variant === 'contained' ? theme.palette.primary.main : 'transparent',
  height: theme.size[14],
  minWidth: 0,
  borderRadius: theme.spacing.M,
  color: props.variant === 'contained' ? theme.palette.text.inverse : theme.palette.primary.main,
  padding: props.children ? `0 ${theme.spacing.L}` : theme.spacing.M,
  border: props.variant === 'outlined' ? `2px solid ${theme.palette.primary.main}` : 'none',
  boxShadow: 'none',
  '&:focus': {
    border: props.variant !== 'text' ? `2px solid ${theme.palette.primary.active}` : 'none',
  },
  '&:hover': {
    borderColor: props.variant === 'outlined' ? theme.palette.primary.main : 'none',
    backgroundColor: props.variant === 'contained' ? theme.palette.primary.hover : theme.palette.primary.lightest,
    color: props.variant !== 'contained' ? theme.palette.primary.hover : 'none',
    boxShadow: 'none',
    '& .MuiButton-icon': { color: props.variant === 'outlined' && theme.palette.primary.main },
  },
  '&.MuiButton-root': {
    gap: theme.spacing.SM,
  },
  '&.Mui-disabled': {
    backgroundColor: props.variant === 'contained' ? theme.palette.background.disabled : 'transparent',
    color: theme.palette.text.disabled,
    border: props.variant === 'outlined' ? `2px solid ${theme.palette.text.disabled}` : 'none',
  },
  '& .MuiButton-icon': {
    padding: 0,
    margin: 0,
  },
  '& .MuiTouchRipple-child': {
    backgroundColor: props.variant === 'contained' ? theme.palette.primary.selected : theme.palette.primary.hover,
  },
  '& .MuiButton-loadingIndicator': {
    position: 'unset',
  },
})) as typeof Button
